import { logger } from 'helpers/logger'
import { useEffect, MutableRefObject } from 'react'
import { useDispatch } from 'react-redux'
import { wsOnMessage } from '@wellesley/host-remote/api/actions'
import { WsOnMessage, WsSubscribeMessage } from '../../types'
import { getErrorByCode } from '../helpers/getErrorByCode'
import ReconnectingWebSocket from 'reconnecting-websocket'

type UseWsEventsProps = {
  onReady: (isReady: boolean) => void
  socket: ReconnectingWebSocket | null
  serverSubscriptions: MutableRefObject<WsSubscribeMessage[]>
}

export const useWsEvents = ({
  onReady,
  socket,
  serverSubscriptions,
}: UseWsEventsProps) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!socket) return

    socket.onopen = () => {
      serverSubscriptions.current = []
      onReady(true)
      logger.info('Connected to WebSocket server')
    }

    socket.onmessage = (event: MessageEvent<string>) => {
      logger.debug('WebSocket receive message: ', JSON.parse(event.data))
      try {
        dispatch(
          wsOnMessage({
            ...(JSON.parse(event.data) as WsOnMessage),
            date: new Date().toISOString(),
          }),
        )
      } catch (e) {
        logger.error('WebSocket:onmessage:parse: ', e)
      }
    }

    socket.onclose = (event) => {
      onReady(false)
      logger.info('Disconnected from WebSocket server:', getErrorByCode(event))
    }

    socket.onerror = (error) => {
      onReady(false)
      logger.error('WebSocket error:', error)
    }
  }, [socket])
}
